import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'underscore';
import moment from 'moment';
import numbro from 'numbro';
import ga from 'analytics';

import {colors} from 'style';
import DatabaseService from 'services/DatabaseService.js';
import StepsChallenge from './StepsChallenge';
import {getUserProfileWithDefaults} from 'reducers/user.js';


const LargeChartEndDataIndex = 29;
const MobileChartEndDataIndex = 4;

const chartOptions = {
    maintainAspectRatio: false,
    legend:{
        position: 'bottom',
        labels: {
            fontSize: 16 }
    },
    scales: {
        xAxes: [
            {
                ticks: {
                    fontSize: 16
                },
                gridLines: {
                    display:false
                }
            }
        ],
        yAxes: [
            {
                ticks: {
                    fontSize: 16,
                    callback: function(label, index, labels) {
                        return numbro(Number(label)).format({trimMantissa: true, mantissa: 1, thousandSeparated: true});
                    },
					suggestedMax: 20000,
                },
                gridLines: {
                    display:false
                }   
            }
        ]
    },
	plugins: {
		datalabels: {
			align: 'top',
            anchor: 'bottom',
			backgroundColor: function(context) {
				return context.dataset.backgroundColor;
			},
			borderRadius: 4,
			color: 'white',
			font: {
				weight: 'bold'
			},
			formatter: Math.round,
			display: function(context) {
                console.log('datalabels:');
                console.log(context);
				return context.datasetIndex===0 && context.dataIndex === LargeChartEndDataIndex;
			}
		}
	},
};


const mobileChartOptions = {
	...chartOptions,
	plugins: {
		datalabels: {
			align: 'top',
            anchor: 'bottom',
			backgroundColor: function(context) {
				return context.dataset.backgroundColor;
			},
			borderRadius: 4,
			color: 'white',
			font: {
				weight: 'bold'
			},
			formatter: Math.round,
			display: function(context) {
                console.log('datalabels:');
                console.log(context);
				return context.datasetIndex===0 && context.dataIndex === MobileChartEndDataIndex;
			}
		}
	},
};

const daysPerWeek = 7;
const historyLimitDays = 30;

class StepsChallengeContainer extends Component {
    constructor(props){
        super(props);
        var today = new Date();
        var lastWeek = moment(today).subtract(daysPerWeek, 'days').toDate();
        this.state = {value:'', 
					  historyData:[], 
					  averageData:[],
                      startedAt: today,
                      today: today,
                      lastWeek: lastWeek,
					  showModal:false,
					  mobileChartOffset: 0};
        this.input = null;
        this.onComplete = this.onComplete.bind(this);
        this.onChange = this.onChange.bind(this);
        this.loadData = this.loadData.bind(this);
		this.onOpenModal = this.onOpenModal.bind(this);
		this.onCloseModal = this.onCloseModal.bind(this);
		this.onChangeStartedAt = this.onChangeStartedAt.bind(this);
		this.onChangeMobileChartDate = this.onChangeMobileChartDate.bind(this);
    }
    componentWillMount() {
        this.loadData();
        ga('send', 'pageview', { 'page': '/virtual/steps-challenge' }); 
    }
    loadData() {
        DatabaseService.fetchChallenge(this.props.challenge.id, {average:true, averageLimit:historyLimitDays, history:true, historyLimit:historyLimitDays})
            .then((result)=>{
                var historyData = this.process(result.history);
                var averageData = this.process(result.averages);
                this.setState({historyData, averageData});
                console.log('data:', {historyData, averageData});
            });
    }

    process(items) {
        var itemsMap = items.reduce((m,item)=>{
                            m[item.utcDate]=item;
                            return m;
                        },{});
        var todayLocal = moment();
        var todayUtc = moment.utc([todayLocal.year(), todayLocal.month(), todayLocal.date()]);
        var days = [];
        for(var i = 30; i >=0; i--) {
            days.push(i);
        }
        return days.map((offset)=>{
            var dayUtc = todayUtc.clone().subtract(offset, 'days');
            var dayUtcIsoDateString = dayUtc.toISOString();
            var item = itemsMap[dayUtcIsoDateString];
            var actionsCompleted = item ? item.actionsCompleted : 0;
            var points = item ? item.points : 0;
            var resources = item ? item.resources : 0;
            return {date:dayUtc, isoDateString:dayUtcIsoDateString, value:actionsCompleted, actionsCompleted, points, resources, ...item};
        });
    }

	onOpenModal() {
		this.setState({showModal:true, startedAt:this.state.today, value:''});
	}

	onCloseModal() {
		this.setState({showModal:false});
	}

    onComplete(event) {
		if(event) {
			event.preventDefault();
		}
        var increment = this.state.value;
        if(_.isFinite(increment) && increment>0) {
			var now=!moment(this.state.startedAt).isBefore(this.state.today);
			var timestampOptions = now ? {} : {startedAt:this.state.startedAt};
            this.props.onComplete(this.props.challenge.id, {...timestampOptions, actions:{increment:this.state.value}}).then(this.loadData);
            this.setState({value:''});
        }
    }

    onChange(event) {
        var value = event.target.value;
        if(value) {
            if(value > 90000) {
                value = 90000;
            } else if(value < 0) {
                value = 0;
            }
        }
        this.setState({value:value});
    }

    onChangeStartedAt(inc) {
        this.setState(s => ({startedAt:moment(s.startedAt).add(inc, 'days').toDate()}));
    }

	onChangeMobileChartDate(inc) {
        this.setState(s => ({mobileChartOffset:Math.max(0,Math.min(25,s.mobileChartOffset+inc))}));
	}

    cancelDoubleClick(event) {
        event.stopPropagation();
    }

    getChartData(limit, offset) {
        var historyData = this.state.historyData; 
        var averageData = this.state.averageData; 
        if(averageData.length==0) {
            return null;
        } 

		if(limit) {
			historyData = historyData.slice().reverse().filter((hd,i)=>Boolean(i >= offset && i<(limit+offset))).slice().reverse();
			averageData = averageData.slice().reverse().filter((ad,i)=>Boolean(i >= offset && i<(limit+offset))).slice().reverse();
		}

        var result = {
              dateRange: historyData[0].date.format('ddd, MMM DD') + ' - ' + historyData[historyData.length-1].date.format('ddd, MMM DD'),
              labels: averageData.map(item=>item.date.format('M-DD')),
              datasets: [
                {
				  type: 'line',
                  label: this.props.t('common_goal'),
                  backgroundColor: colors.pointsYellow,
                  borderColor: colors.pointsYellow,
                  fill: false,
                  borderWidth: 1,
                  hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                  hoverBorderColor: 'rgba(255,99,132,1)',
				  pointRadius: 0,
				  pointHoverRadius: 0,
                  data: averageData.map(item=>this.props.challenge.actionsMax)
                },
                {
                  label: this.props.t('You'),
                  backgroundColor: colors.themeTeal,
                  borderColor: colors.themeTeal,
                  borderWidth: 1,
                  borderRadius: 5,
                  hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                  hoverBorderColor: 'rgba(255,99,132,1)',
                  data: historyData.map(item=>item.value)
                },
                {
                  label: this.props.t('Average User'),
                  backgroundColor: colors.themeDarkGrey,
                  borderColor: colors.themeDarkGrey,
                  borderWidth: 1,
                  hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                  hoverBorderColor: 'rgba(255,99,132,1)',
                  data: averageData.map(item=>item.value)
                },
              ]
            };
        return result;
    }

    render() {
        var history = this.state.historyData;
        var selectedHistory = {actionsCompleted:0, points:0, resources: 0};
        var todayHistory    = {actionsCompleted:0, points:0, resources: 0};
        var startedAtMoment = moment(this.state.startedAt);
        var startedAtUTC 	= moment.utc([startedAtMoment.year(), startedAtMoment.month(), startedAtMoment.date()]);
        var todayMoment 	= moment(this.state.today);
        var todayUTC 		= moment.utc([todayMoment.year(), todayMoment.month(), todayMoment.date()]);
        for(var i = 0; i < history.length; i++) {
            var historyItem = history[i];
            var utcDate = moment(historyItem.utcDate).utc();
            if(utcDate.year()  ===  startedAtUTC.year() &&
               utcDate.month() ===  startedAtUTC.month() &&
               utcDate.date()  ===  startedAtUTC.date()) {
                selectedHistory = historyItem;
            }
            if(utcDate.year()  ===  todayUTC.year() &&
               utcDate.month() ===  todayUTC.month() &&
               utcDate.date()  ===  todayUTC.date()) {
                todayHistory = historyItem;
				console.log('found today', todayHistory);
            }
        }
        var challenge = this.props.challenge;
        var sevenDayHistoryData = history.slice().reverse().filter((hd,i)=>Boolean(i<7));
        var sevenDayHistoryTotal   = sevenDayHistoryData.reduce((sum,hd)=>(sum+hd.value),0);
        var sevenDayHistoryAverage = sevenDayHistoryTotal/7;
        return <StepsChallenge startedAt={this.state.startedAt}
							   challenge={challenge}
							   showModal={this.state.showModal}
                               historyData={this.state.historyData}
                               selectedHistory={selectedHistory}
                               today={this.state.today}
                               todayHistory={todayHistory}
                               sevenDayHistoryData={sevenDayHistoryData}
                               sevenDayHistoryAverage={sevenDayHistoryAverage}
                               sevenDayHistoryTotal={sevenDayHistoryTotal}
                               chartData={this.getChartData()}
							   chartDataMobile={this.getChartData(5, this.state.mobileChartOffset)}
                               chartOptions={chartOptions}
                               mobileChartOptions={mobileChartOptions}
                               cancelDoubleClick={this.cancelDoubleClick}
                               enableDateIncrease={moment(this.state.startedAt).isBefore(this.state.today)}
                               enableDateDecrease={moment(this.state.startedAt).isAfter(this.state.lastWeek)}
                               enableMobileChartDateIncrease={this.state.mobileChartOffset > 0}
                               enableMobileChartDateDecrease={this.state.mobileChartOffset < 25}
                               onComplete={this.onComplete}
                               completePending={this.props.completePending}
                               userChallenge={this.props.userChallenge}
                               onChange={this.onChange}
							   onChangeMobileChartDate={this.onChangeMobileChartDate}
                               onOpenModal={this.onOpenModal}
                               onCloseModal={this.onCloseModal}
                               onChangeStartedAt={this.onChangeStartedAt}
                               onShowLeaderboards={this.onShowLeaderboards}
                               value={this.state.value}
                               canAddSteps={this.props.userProfile.id && this.props.userProfile.companyId !== 273} />;
    }

}

const mapStateToProps = (state, ownProps) => {
    return {  userProfile: getUserProfileWithDefaults(state.user) };
}

export default withRouter(connect(mapStateToProps)(translate('challenges')(StepsChallengeContainer)));



// WEBPACK FOOTER //
// ./src/modules/challenges/types/StepsChallengeContainer.js